import { render, staticRenderFns } from "./livingUpdate_list.vue?vue&type=template&id=44d2c31a&scoped=true&"
import script from "./livingUpdate_list.vue?vue&type=script&lang=js&"
export * from "./livingUpdate_list.vue?vue&type=script&lang=js&"
import style0 from "./livingUpdate_list.vue?vue&type=style&index=0&id=44d2c31a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d2c31a",
  null
  
)

export default component.exports